module.exports = __webpack_public_path__ + "media/newstyle/images/brand-tiktok-svgrepo-com-92f430729b703cfe9f8f9973d29b0061.svg";